// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2XZph","footer":"ReportModalFilter_footer__3D-kB"};